import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import Header from '../../components/header/index.js'
import Footer from '../../components/footer/index.js'
import ManualFileSearch from '../../components/manualFileSearch/index.js'

const SearchManualFile = () => {

    return (
        <div>
            <Header />

            <ManualFileSearch />

            <Footer />
        </div>
    );
}

export default SearchManualFile;
